import { render, staticRenderFns } from "./igm.vue?vue&type=template&id=7b580c04&scoped=true&"
import script from "./igm.vue?vue&type=script&lang=js&"
export * from "./igm.vue?vue&type=script&lang=js&"
import style0 from "./igm.vue?vue&type=style&index=0&id=7b580c04&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b580c04",
  null
  
)

export default component.exports